module.exports = __webpack_public_path__ + "static/img/introductionTitle.71dd1fa4.png";